import * as React from "react";
import { HeadingLarge, HeadingSmall } from "kanopi-components/typography";
import { HighlightCircle } from "./HighlightCircle";
import { Image } from "kanopi-components/Image";
import { Kontainer } from "kanopi-components/Layout/Kontainer";
import { navigate } from "@reach/router";
import { Placeholder } from "kanopi-components/Placeholder";
import { RegisterForm } from "kw/components/RegisterForm/RegisterForm";
import { Sektion } from "kanopi-components/Layout/Sektion";
import { SidePadder } from "kanopi-components/Layout/SidePadder";
import { StatelessPolicyConfirmedInformation } from "kw/quoting/components/StatelessPolicyConfirmedInformation";
import { useUser } from "kw/auth/useUser";

type TProps = {
  riskProfiles: TRiskProfile[];
  loading?: boolean;
};

const StatelessPolicyConfirmed: React.FC<TProps> = (props) => {
  const { riskProfiles = [], loading } = props;
  // Ensure we get the current period.
  const user = useUser();
  const onRegistrationComplete = React.useCallback(() => {
    if (riskProfiles[0]?.policyPeriods?.length > 0) {
      if (riskProfiles.length > 1) {
        navigate("/policies", {
          replace: true,
        });
      } else {
        navigate(`/policies/${riskProfiles[0]?.policyPeriods[0]?.policy?.id}`, {
          replace: true,
        });
      }
    }
  }, [riskProfiles[0]?.policyPeriods]);

  return (
    <Placeholder loading={loading}>
      {/* TODO: Revert Kontainer to original default padding behavior so that this isn't needed */}
      <SidePadder>
        <Kontainer>
          <Sektion compact>
            <HighlightCircle>
              <Image src="icons/check-black.svg" />
            </HighlightCircle>
            <HeadingSmall center marginBottom="scale200">
              Thank you.
            </HeadingSmall>
            <HeadingLarge center marginTop="scale200">
              You are now covered
            </HeadingLarge>
          </Sektion>
        </Kontainer>

        {riskProfiles.map((riskProfile) => (
          <StatelessPolicyConfirmedInformation
            key={riskProfile.id}
            riskProfileId={riskProfile.id}
            policyPeriods={riskProfile.policyPeriods}
            paymentFrequency={riskProfile.paymentFrequency}
            periodicPrice={riskProfile.periodicPrice}
            startDate={riskProfile.startDate}
            finishDate={riskProfile.finishDate}
            loading={loading}
            productKey={riskProfile?.enabledProducts[0]?.key}
          />
        ))}

        {user?.allowCustomerPortalAccess && user?.isPasswordLess && (
          <Kontainer>
            <RegisterForm
              hideEmail={true}
              onRegistrationComplete={onRegistrationComplete}
            />
          </Kontainer>
        )}
      </SidePadder>
    </Placeholder>
  );
};

export { StatelessPolicyConfirmed };
